import { render } from "./app-sjb-header.vue?vue&type=template&id=4be32818&scoped=true&ts=true"
import script from "./app-sjb-header.vue?vue&type=script&lang=ts"
export * from "./app-sjb-header.vue?vue&type=script&lang=ts"

import "./app-sjb-header.vue?vue&type=style&index=0&id=4be32818&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be32818"]])

export default __exports__